module.exports = __webpack_public_path__ + "img/IngoSchimpff.b289bba3.jpg";